






















































import { Component, Vue } from 'vue-property-decorator'
import SearchForm from './components/searchForm.vue'
import Pagination from '@/views/components/pagination.vue'
import OperationModal from './components/operationModal.vue'
import AuthModal from './components/authModal.vue'
import { ListResponse, ListItemProps } from './index.d'
import { getList, isDisable, isEnable } from '@/api/account'

@Component({
  name: 'AccountList',
  components: {
    SearchForm,
    Pagination,
    OperationModal,
    AuthModal
  }
})
export default class extends Vue {
  private params = {
    currentPage: 1,
    pageSize: 10
  }

  private total = 0
  private loading = false
  private tableData: ListItemProps[] = []
  private operationDialogFlag = false
  private authDialogFlag = false
  private id: null | number = null

  created() {
    this.onLoad()
  }

  // 获取数据
  private async onLoad() {
    this.loading = true
    const { content } = await getList<ListResponse>(this.params)
    this.total = content.total
    this.tableData = content.content
    this.loading = false
  }

  // 搜索
  private onSearchSubmit(params: any) {
    this.params = Object.assign(this.params, params)
    this.onLoad()
  }

  // 分页
  private onPaginationSbumit(currentPage: number, pageSize: number) {
    this.params = Object.assign(this.params, { currentPage, pageSize })
    this.onLoad()
  }

  // 弹窗回调
  private onDialogSubmit() {
    console.log('回调')
    this.params.currentPage = 1
    this.onLoad()
  }

  // 禁用or启用
  private handleDisableorEnable(id: number, status: number) {
    const tips = status === 1 ? '禁用' : '启用'
    this.$confirm(`是否${tips}账号？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      status === 1 ? await isDisable({ id }) : await isEnable({ id })
      this.$message.success(`${tips}成功`)
      this.onLoad()
    })
  }

  // 授权
  private handleAuth(id: number) {
    this.id = id
    this.authDialogFlag = true
  }

  // 打开操作弹窗（新增/修改）
  private openOperationDialog(id: null | number) {
    this.id = id
    this.operationDialogFlag = true
  }
}
